import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative h-screen min-h-[600px] w-full flex items-center justify-center overflow-hidden bg-weiss" data-id="element-107">
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto mt-16" data-id="element-108">
        <motion.h1 initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-5xl md:text-7xl lg:text-[5.5rem] font-poppins font-bold text-schwarz leading-tight mb-4 text-balance uppercase tracking-tight" data-id="element-109">
          Ihr Lächeln.
          <br data-id="element-110" />
          Unsere Berufung.
        </motion.h1>

        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 0.8,
        delay: 0.8,
        ease: 'easeOut'
      }} className="h-[2px] w-24 bg-gold mx-auto mt-8 mb-8 origin-center" data-id="element-111" />

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1.0,
        ease: 'easeOut'
      }} className="text-lg md:text-xl text-gray-medium font-lora tracking-widest uppercase" data-id="element-112">
          Zahnarztpraxis edel & weiss — Nürnberg
        </motion.p>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center" data-id="element-113">
        <span className="text-xs text-gray-light uppercase tracking-widest mb-2 font-poppins font-bold" data-id="element-114">
          Scrollen
        </span>
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-115">
          <ChevronDownIcon className="w-5 h-5 text-gold" data-id="element-116" />
        </motion.div>
      </motion.div>
    </section>;
}